import { Component, OnInit } from '@angular/core';
import { AssinaturaEletronicaService } from 'src/app/services/assinatura-eletronica.service';
import { HttpErrorResponse } from '@angular/common/http';
import { finalize } from 'rxjs/operators';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';

import { ReactiveFormsModule, FormsModule } from '@angular/forms';
@Component({
    selector: 'app-assinatura-eletronica',
    templateUrl: './assinatura-eletronica.component.html',
    styleUrls: ['./assinatura-eletronica.component.css'],
    imports: [ReactiveFormsModule, FormsModule]
})
export class AssinaturaEletronicaComponent implements OnInit {

  loadingEmail: boolean = false;
  loadingSalvar: boolean = false;

  emailOk: boolean = false;
  msgErro: string = null;

  form: FormGroup = null;

  constructor(private assEletronica: AssinaturaEletronicaService, private toastr: ToastrService) {

    this.form = new FormGroup({
      token: new FormControl(null, [Validators.required]),
      assinatura: new FormControl(null, [Validators.required, Validators.minLength(8)]),
      confAssinatura: new FormControl(null, [Validators.required, Validators.minLength(8)])
    });

  }

  ngOnInit() {
  }

  enviarEmail(){

    this.loadingEmail=true;

    this.assEletronica
        .esqueciMinhaAssinatura()
        .pipe(
          finalize(() => { this.loadingEmail=false })
        )
        .subscribe(
          (res: boolean) => {

            this.emailOk = true;

          },
          (httpError: HttpErrorResponse) => {

          }
        )


  }

  alterarAssinatura(): boolean {

    if(!this.validarAssinatura()){

      setTimeout(()=>{
        this.msgErro = null;
      }, 5000);

      return false;
    }


    this.loadingSalvar = true;

    this.assEletronica
        .alterarAssinatura(this.form.value)
        .pipe(
          finalize(() => { this.loadingSalvar=false })
        )
        .subscribe(
          (res: boolean) => {

            if(res){
              this.toastr.success("Assinatura eletrônica alterada com sucesso");
              this.form.reset();
              this.emailOk = false;
            }

          },
          (error: HttpErrorResponse) => {

            this.msgErro = error.error.ex;

            if(error.error.type=="validacaoIgual" || error.error.type=="validacaoTamanho"){
              this.form.get("assinatura").setValue("");
              this.form.get("confAssinatura").setValue("");
            }

            setTimeout(()=>{
              this.msgErro = null;
            }, 5000);

          }
        )

    return true;
  }

  validarAssinatura(): boolean{


    var assinatura: string = this.form.get("assinatura").value;
    var confAssinatura: string = this.form.get("confAssinatura").value;

    if(!assinatura.match(/([0-9])/)){
      this.msgErro = "A assinatura deve ter no mínimo um caracter numérico";
      return false;
    }

    if(!assinatura.match(/([a-zA-Z])/)){
      this.msgErro = "A assinatura deve ter no mínimo um caracter alfabético";
      return false;
    }

    if(assinatura != confAssinatura){
      this.msgErro = "As assinatura não são iguais";
      return false;
    }

    return true;
  }

}
